import React from 'react';
import { connect } from 'react-redux';

// Components

import IdahoFooter from '@common-components/footers/IdahoFooter';
import MinnesotaFooter from '@common-components/footers/MinnesotaFooter';
import NevadaFooter from '@common-components/footers/NevadaFooter';
import New_JerseyFooter from '@common-components/footers/New_JerseyFooter';
import New_MexicoFooter from '@common-components/footers/New_MexicoFooter';
import PennsylvaniaFooter from '@common-components/footers/PennsylvaniaFooter';
import GeorgiaFooter from '@common-components/footers/GeorgiaFooter';
import VirginiaFooter from '@common-components/footers/VirginiaFooter';
import IllinoisFooter from '@common-components/footers/IIllinoisFooter';
import GetinsuredFooter from '@common-components/footers/GetinsuredFooter';

// Constants

import { configs } from '@constants/configs/configs';
import CaliforniaFooter from '@common-components/footers/CaliforniaFooter';



const FooterContainer = props => {

    const {
        environment,
        environment: {
            stateCode
        }
    } = props;

    switch(true) {
        case stateCode === configs.states.CALIFORNIA:
            return <CaliforniaFooter {...{ environment }}/>;
        case stateCode === configs.states.IDAHO:
            return <IdahoFooter {...{ environment }}/>;

        case stateCode === configs.states.MINNESOTA:
            return <MinnesotaFooter {...{ environment }}/>;

        case stateCode === configs.states.NEVADA:
            return <NevadaFooter {...{ environment }}/>;

        case stateCode === configs.states.NEW_JERSEY:
            return <New_JerseyFooter {...{ environment }}/>;

        case stateCode === configs.states.NEW_MEXICO:
            return <New_MexicoFooter {...{ environment }}/>;

        case stateCode === configs.states.PENNSYLVANIA:
            return <PennsylvaniaFooter {...{ environment }}/>;

        case stateCode === configs.states.GEORGIA:
            return <GeorgiaFooter {...{ environment }}/>;

        case stateCode === configs.states.VIRGINIA:
            return <VirginiaFooter {...{ environment }}/>;

        case stateCode === configs.states.ILLINOIS:
            return <IllinoisFooter {...{ environment }}/>;

        case stateCode === configs.states.GETINSURED:
            return <GetinsuredFooter {...{ environment }}/>;

        default:
            return null;
    }
};

const mapStateToProps = state => ({
    environment: state.common.environment
});

export default connect(mapStateToProps)(FooterContainer);
